module.exports = __webpack_public_path__ + "static/img/logo.c1182bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 28
// module chunks = 1